import { render } from "./GrafanaChartCard.vue?vue&type=template&id=2c138b17&scoped=true"
import script from "./GrafanaChartCard.vue?vue&type=script&lang=js"
export * from "./GrafanaChartCard.vue?vue&type=script&lang=js"

import "./GrafanaChartCard.vue?vue&type=style&index=0&id=2c138b17&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c138b17"]])

export default __exports__